<template>
  <section class="comp-header bb-3">
    <div class="header-inner">
      <div class="logo pt20">
        <router-link to="/"><img src="../assets/imgs/logo.png" alt="logo"></router-link>
      </div>
      <div style="padding-top: 25px;margin-left: 20px;" v-if="$route.name == 'Index'">
        <el-dropdown :class="{'disabled': subjectChangeDisabled.includes($route.name)}" trigger="click" size="small" placement="bottom-start" @command="bindChangeSubject">
          <el-button style="padding:8px;" size="mini">
            {{currentSubject.fullname}}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" class="header-subject-menu">
            <el-dropdown-item v-for="item of subjectList" :key="item.id" :class="{active: currentSubject.id == item.id}" :command="item">{{item.fullname}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="head-menu f15">
        <router-link class="f-menu" to="/">首页</router-link>
        <router-link class="f-menu" :to="{name: 'ZNZJ'}">智能组卷</router-link>
        <router-link class="f-menu" :to="{name: 'MBZJ'}">模板组卷</router-link>
        <router-link class="f-menu" :to="{name: 'KDZJ'}">考点组卷</router-link>
        <!--<router-link class="f-menu" :to="{name: 'ZJZJ'}">章节组卷</router-link>-->
        <router-link class="f-menu" :to="{name: 'MXMJ'}">名校名卷</router-link>
        <!--<router-link class="f-menu" :to="{name: 'DailyPaper'}">每日上新</router-link>-->
        <router-link class="f-menu" :to="{name: 'User'}">用户中心</router-link>
<!--        <router-link class="f-menu" :to="{name: 'VIP'}">VIP会员</router-link>-->
        <a class="f-menu red-dot" href="https://www.wlnkaoshi.com/" target="_blank">考试在线</a>
      </div>
      <div class="header-search">
        <el-input
          placeholder="搜索试题、试卷"
          @focus="searchInputFocus = true"
          @click="searchInputFocus = true"
          @blur="searchInputFocus = false"
          clearable
          @keyup.enter.native="bindSearch"
          @clear="bindSearch"
          class="search-input"
          :class="{'focus': searchInputFocus}"
          v-model="searchInputKeywords">
        </el-input>
        <a title="搜索" @click="bindSearch" class="search-btn" href="javascript:">
          <i class="el-icon-search"></i>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/17
   * @project kaoshizhongxin-pc
   * @desc 公共头部组件
   */
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import {loginCBMixin} from '../mixins/login-callback'

  export default {
    name: 'comp-header',
    props: {},
    mixins: [loginCBMixin],
    data () {
      return {
        searchInputFocus: false,
        searchInputKeywords: this.$route.query.keywords || '',
        subjectChangeDisabled: ['EditTpl'],
        curRouter: this.$route.name
      }
    },
    computed: {
      ...mapState(['scrollTop']),
      ...mapState('common', ['subjectList']),
      ...mapGetters('common', ['currentSubject']),
      ...mapGetters('user', ['isLogin', 'userPic', 'nickname'])
    },
    methods: {
      ...mapMutations('common', ['updateSubject']),
      bindSearch () {
        let route = {name: 'Search', query: {keywords: this.searchInputKeywords}}
        this.$route.name === 'Search' ? this.$router.push(route) : this.$router.replace(route)
      },
      bindChangeSubject (data) {
        let routeName = this.$route.name
        this.updateSubject(data.id)
        let routerArr = ['UserQues', 'UserDocSavedList', 'UserDocDownList', 'UserQuesComment', 'Search', 'MXMJ', 'DailyPaper', 'PaperView', 'ZJZJ', 'KDZJ', 'MBZJ', 'ZNZJ']
        this.loginCB({}, 1)
        if (routerArr.includes(routeName)) {
          this.bus.$emit('changeSubjectID_' + routeName, data)
        }
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/_mixins-wln";
  .header-subject-menu {
    display: flex;
    width:242px;
    flex-flow: wrap;
    padding:10px;
    li {
      width:33.33%;
      padding: 0!important;
      text-align: center;
      margin:3px 0;
      &.active {
        background-color: #ecf5ff;
        color: #66b1ff;
      }
    }
  }
  .comp-header {
    background: @white;
    width: 100%;

    .header-inner {
      position: relative;
      width: @body-min-width;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
    }

    .logo {
      width: 280px;
    }

    .head-menu {
      height: 80px;
      display: flex;
      flex: 1;
      flex-direction: row;
      padding-top: 20px;
      padding-right: 130px;
      justify-content: flex-end;

      .f-menu {
        font-size: 15px;
        padding: 0 8px;
        position: relative;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        &.red-dot {
          color:@primary;
          font-weight: bold;
          /*&:after{*/
          /*  content: '';*/
          /*  position: absolute;*/
          /*  height: 8px;*/
          /*  width: 8px;*/
          /*  border-radius: 50%;*/
          /*  top:10px;*/
          /*  right:10px;*/
          /*  background: #ff3631;*/
          /*}*/
        }
        &.exact-active{
          font-weight: bold;
          &:after{
            content: '';
            position: absolute;
            height: 2px;
            width: 90%;
            background: #00AAFF;
            bottom: 18px;
            transform: translateX(-93%);
          }
        }
        &:first-child.exact-active:after{
          transform: translateX(-86%);
        }
      }
    }

    .header-search {
      position: absolute;
      right: 0;
      top: 21px;
      display: flex;
      input {
        padding: 0 10px;
        border-radius: 3px 0 0 3px;
      }

      .search-input {
        width: 90px;
        transition: width 0.3s;

        &.focus {
          width: 280px;
        }
      }
      .search-btn{
        border:1px solid #DCDFE6;
        border-left:none;
        height:36px;
        width:36px;
        justify-content: center;
        border-radius: 0 3px 3px 0;
        display:inline-flex;
        align-items: center;
      }
    }
  }

  .header-fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 20;
    box-shadow: 0 3px 3px rgba(3, 26, 62, 0.18);
  }
</style>
